(function () {
/*
 * -----------------------------------------------------------------------------
 * @cam/search-form-disclosure
 * -----------------------------------------------------------------------------
 * @version 0.0.1
 * @overview Togglable details element with search form progressive enhancement.
 * @copyright 2021 Cam Gould & Elkfox Co Pty Ltd - All rights reserved
 * ------------------------------------------------------------------------------
 * @requires @cam/search-form
 * -----------------------------------------------------------------------------
*/ if (customElements.get("search-form-disclosure") === undefined) {
    class SearchFormDisclosure extends HTMLElement {
        constructor(){
            super();
            this.detailsElement = this.querySelector("details");
            this.detailsSummary = this.querySelector("summary");
            this.detailsDisclosure = Array.prototype.slice.call(this.detailsElement.children).find((element)=>element != this.detailsSummary);
            this.searchForm = this.querySelector("search-form");
            this.closeButton = this.querySelector('[name="close"]');
            this.trapFocus = this.trapFocus.bind(this);
            this.clickEvents = this.clickEvents.bind(this);
            this.detailsDisclosure.addEventListener("keyup", this.onKeyup.bind(this));
            this.detailsSummary.addEventListener("click", this.toggleSearchForm.bind(this), false);
            this.closeButton?.addEventListener("click", this.toggleSearchForm.bind(this), false);
        }
        onKeyup(event) {
            if (event.code != "Escape") return;
            event.preventDefault();
            this.toggleSearchForm();
        }
        toggleSearchForm(event) {
            if (event) event.preventDefault();
            this.input = this.detailsDisclosure.querySelector('input[type="search"]');
            if (this.detailsElement.getAttribute("open") === null) {
                this.detailsElement.setAttribute("open", "");
                this.focusInterval = setInterval(this.takeFocus.bind(this), 10);
                this.detailsDisclosure.addEventListener("focusout", this.trapFocus);
                document.addEventListener("click", this.clickEvents);
            } else {
                this.detailsElement.removeAttribute("open");
                this.detailsDisclosure.removeEventListener("focusout", this.trapFocus);
                document.removeEventListener("click", this.clickEvents);
                this.detailsSummary.focus();
                if (this.detailsDisclosure) this.searchForm.closeResults(true);
            }
        }
        takeFocus() {
            if (this.input === document.activeElement) {
                clearInterval(this.focusInterval);
                return;
            }
            this.input.focus();
        }
        trapFocus(event) {
            if (this.detailsDisclosure.contains(event.relatedTarget)) return;
            this.detailsDisclosure.querySelectorAll('button, [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])')[0].focus();
        }
        clickEvents(event) {
            if (this.contains(event.target)) return;
            this.toggleSearchForm();
        }
    }
    customElements.define("search-form-disclosure", SearchFormDisclosure);
}



})();
